import NetearCobranzasPage from "./NetearCobranzasPage";

export {NetearCobranzasPage}
export default NetearCobranzasPage
